<div id="frm_add_or_edit"  style="overflow: hidden">
  <div class="row">
    <!-- sidebar left - Thông tin tài liệu -->
    <div [hidden]="tabMode === 'hide'" class="col-lg-5 col-md-12 col-sm-12 pr-0">
      <div class="card" style="
          height: calc(100vh - 140px);
          overflow-y: auto;
          border-radius: 0px !important;
          padding-bottom: 50px;
          border: none;
        ">
        <app-panel-document-view (navigate)="onBackClick()" [documentTypeEnterprise]="documentTypeEnterprise" >
        </app-panel-document-view>
        <div *ngIf="checkMan">
          <mat-expansion-panel  [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title class panel-title">
                {{ "form.order_of_approval_signing_contract_unit" | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <mat-form-field class="w-100">
                <mat-label>{{ "file_sign" | translate }}
                </mat-label>

                <mat-select (selectionChange)="changeFileAddSign($event,'selectFileSign')"
                            [(ngModel)]="selectedFileSign">
                  <mat-option *ngFor="let file of fileUploads;let i = index" [value]="i">
                    {{ file.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <nz-table #expandTable nzTableLayout="fixed" [nzFrontPagination]="false" [nzShowPagination]="false" class="ant-table-no-placeholder-border-bottom table-user-sign" nzBordered >
              <thead>
              <tr>
                <th class="text-center" nzWidth="10%">
                  {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}
                </th>
                <th class="text-center" nzWidth="40%">
                  {{ "enterprise_contract.panel_document.table_users.header.name" | translate }}
                </th>
                <th class="text-center" nzWidth="25%">
                  {{ "enterprise_contract.panel_document.table_users.header.role" | translate }}
                </th>
                <th class="text-center" nzWidth="10%">
                  {{ "enterprise_contract.panel_document.table_users.header.page" | translate }}
                </th>
                <th class="text-center" nzWidth="15%">
                  {{ "enterprise_contract.panel_document.table_users.header.action" | translate }}
                </th>
              </tr>
              </thead>
              <tbody>
              <!-- nguoi dung phe duyet ben lap -->
<!--              <tr *ngIf="listApproverSign.length">-->
<!--                <td colspan="5">-->
<!--                  {{ "enterprise_contract.sign_table.approve_sign" | translate }}-->
<!--                </td>-->
<!--              </tr>-->
              <ng-container *ngFor="let data of listApproverSign; let i = index">
                <tr>
                  <td class="text-center">{{ data.order }}</td>
                  <td matTooltip="{{
                          data.name?data.name:''
                        }} - {{data.email?data.email:''}}">
                    {{ data.name }}
                  </td>
                  <td class="text-center">
                    {{'search_form.approve_doc' | translate}}
                  </td>
                  <td></td>
                  <td class="text-center" *ngIf="data.CTS && data.showImage">
                    <button (click)="addSign(data)" color="primary" mat-icon-button
                            type="button">
                      <mat-icon class="mr-0" matTooltip="{{
                          'enterprise_contract.tooltips.add_sign_new' | translate
                        }}">add_circle
                      </mat-icon>
                    </button>
                  </td>
                  <td *ngIf="!data.CTS || !data.showImage"></td>
                </tr>
                <ng-container *ngFor="let sign of listSign; let id = index">
                  <tr *ngIf="sign.userId == data.userId && checkHaveSign(data, sign)">
                    <td></td>
                    <td colspan="2"> {{ "signature_number" | translate }} {{sign.row_number}}</td>
                    <td class="text-center">{{sign.pageIndex}}</td>
                    <td class="text-center">
                      <button (click)="goToPage(data.enterpriseId, data.userId, sign)"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                        </mat-icon>
                      </button>
                      <!-- <button (click)="deleteSign(data.enterpriseId, data.userId, sign.idNumber)" *ngIf="checkHaveSign(data, sign.idNumber)" -->
                      <button (click)="deleteSign(data.enterpriseId, data.userId, (sign.contractSignId || sign.idNumber))"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                        </mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <!-- nguoi dung ky duyet ben lap -->
<!--              <tr *ngIf="listDataSign.enterprise.length">-->
<!--                <td colspan="5">-->
<!--                  {{ "enterprise_contract.sign_table.create_side" | translate }}-->
<!--                </td>-->
<!--              </tr>-->
              <ng-container *ngFor="let data of listDataSign.enterprise; let i = index">
                <tr>
                  <td class="text-center">{{ data.order }}</td>
                  <td matTooltip="{{
                          data.name?data.name:''
                        }} - {{data.email?data.email:''}}">
                    {{ data.name }}
                  </td>
                  <td class="text-center">
                    {{'search_form.sign_doc'| translate}}
                  </td>
                  <td></td>
                  <td class="text-center">
<!--                    <button (click)="addSign(data)" color="primary" mat-icon-button-->
<!--                            type="button">-->
<!--                      <mat-icon class="mr-0" matTooltip="{{-->
<!--                          'enterprise_contract.tooltips.add_sign' | translate-->
<!--                        }}">add_circle-->
<!--                      </mat-icon>-->
<!--                    </button>-->
                  </td>
                </tr>
                <ng-container *ngFor="let sign of listSign; let id = index">
                  <tr *ngIf="sign.userId == data.userId && checkHaveSign(data, sign)">
                    <td></td>
                    <td colspan="2" *ngIf="sign.row_number"> {{ "signature_number" | translate }} {{sign.row_number}}</td>
                    <td colspan="2" *ngIf="!sign.row_number"> {{ "signature_number" | translate }} </td>
                    <td class="text-center">{{sign.pageIndex}}</td>
                    <td class="text-center">
                      <button (click)="goToPage(data.enterpriseId, data.userId, sign)"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                        </mat-icon>
                      </button>
<!--                      <button (click)="deleteSign(data.enterpriseId, data.userId, (sign.contractSignId || sign.idNumber))"-->
<!--                              color="primary" mat-icon-button type="button">-->
<!--                        <mat-icon class="mr-0" matTooltip="{{-->
<!--                            'enterprise_contract.tooltips.delete_sign' | translate-->
<!--                          }}">close-->
<!--                        </mat-icon>-->
<!--                      </button>-->
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <!-- khach hang -->
<!--              <tr *ngIf="listDataSign.customer.length">-->
<!--                <td colspan="5">-->
<!--                  {{ "enterprise_contract.sign_table.customers" | translate }}-->
<!--                </td>-->
<!--              </tr>-->
              <ng-container *ngFor="let data of listDataSign.customer; let i = index">
                <tr>
                  <td class="text-center">{{data.order }}</td>
                  <td>
                    {{ data.name }}
                  </td>
                  <td class="text-center">
                    {{'search_form.sign_doc'| translate}}
                  </td>
                  <td></td>
                  <td class="text-center">
<!--                    <button (click)="addSign(data)" color="primary" mat-icon-button-->
<!--                            type="button">-->
<!--                      <mat-icon class="mr-0" matTooltip="{{-->
<!--                          'enterprise_contract.tooltips.add_sign' | translate-->
<!--                        }}">add_circle-->
<!--                      </mat-icon>-->
<!--                    </button>-->
                  </td>
                </tr>
                <ng-container *ngFor="let sign of listSign; let id = index">
                  <tr *ngIf="sign.customerId == data.customerId && checkHaveSign(data, sign)">
                    <td></td>
                    <td colspan="2"> {{ "signature_number" | translate }} {{sign.row_number}}</td>
                    <td class="text-center">{{sign.pageIndex}}</td>
                    <td class="text-center">
                      <button (click)="goToPage(data.enterpriseId || data.customerId, data.userId, sign)"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                        </mat-icon>
                      </button>
                      <button (click)="deleteSign(data.enterpriseId || data.customerId, data.userId, (sign.contractSignId || sign.idNumber))"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                        </mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </nz-table>
          </mat-expansion-panel>

          <!-- cấu hình mã hợp đồng -->
          <!-- end cấu hình mã hợp đồng -->

        </div>
      </div>
    </div>


    <!-- View file -->
    <div [ngClass]="{
        'col-lg-7 pl-0': tabMode !== 'hide',
        'col-lg-12': tabMode === 'hide'
      }" class="col-lg-7 col-md-12 col-sm-12" style="padding-right: 0.75rem">
      <div [ngStyle]="{
          'background-color':
            createContractType === 1 && fileUploads.length ? '#a6a6a6' : '#fff'
        }" class="text-left mat-elevation-z0 d-flex justify-content-between align-items-center">
        <div [ngStyle]="{
            'border-bottom-right-radius': activeFile === 0 ? '5px' : '0'
          }" class="pl-3 py-2 box-left">
          <button (click)="tabMode = 'hide'" *ngIf="tabMode !== 'hide'" [matTooltip]="
              'enterprise_contract.tooltips.btn_expand_more' | translate
            " class="mr-2 custom-button-icon" color="primary" mat-stroked-button type="button">
            <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">fullscreen</mat-icon>
          </button>
          <button (click)="tabMode = 'info'" *ngIf="tabMode === 'hide'"
            [matTooltip]="'enterprise_contract.tooltips.info_tab' | translate" class="mr-2 custom-button-icon"
            color="primary" mat-stroked-button type="button">
            <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">info</mat-icon>
          </button>
          <!-- <button class="mr-2 custom-button-icon" mat-stroked-button color="primary" (click)="openTabSign()"
          *ngIf="tabMode === 'hide'" type="button" [matTooltip]="'enterprise_contract.tooltips.sign_tab' | translate">
            <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">border_color</mat-icon>
          </button> -->
        </div>
        <div *ngIf="createContractType === 1 || createContractType === 0" [ngStyle]="{
            background: fileUploads.length
              ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
              : '#fff'
          }" class="tab-file">
          <div style="width: 100%; position: relative; height: 52px;">
            <div class="d-flex box-tab" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)"
              style="position: absolute; width: 100%; top: 0.5rem; left: 0; height: calc(52px - 0.5rem);">
              <div (click)="changeFile(file.path, i)" cdkDrag
                *ngFor="let file of document.mainContractAttachments; let i = index" [class.active]="i === activeFile"
                [class.border-right]="i !== fileUploads.length - 1 && i !== activeFile && i !== activeFile - 1"
                [class.left]="i === activeFile - 1" [class.right]="i === activeFile + 1" [matTooltip]="file.fileName + ' (' + (file.fileSize/1024/1024).toFixed(2) + 'mb)'"
                class="pl-2 py-2 tab d-flex">
                <div class="name">
                  {{ file.fileName }}
                </div>
<!--                <a (click)="removeFile(i)"><span class="material-icons"> close </span></a>-->
              </div>
            </div>
          </div>
        </div>
        <div [ngStyle]="{
            'border-bottom-left-radius':
              activeFile === fileUploads.length - 1 ? '5px' : '0'
          }" class="d-flex pr-3 py-2 box-right">
          <!-- Chọn tệp từ máy -->
          <div class="ml-2">
            <button  (click)="doPrint()"  [matTooltip]="'enterprise_contract.buttons.print' | translate"
              class="mr-2  custom-button-icon" color="primary" id="btnUpload"
              mat-stroked-button type="button">
              <mat-icon class="mr-0">print</mat-icon>
            </button>
          </div>

          <div>
            <button  (click)="openPDFByBrowser(document.id)" [matTooltip]="'enterprise_contract.buttons.download' | translate"
                     class="mr-2  custom-button-icon" color="primary" id="btnUpload"
                     mat-raised-button type="button">
              <mat-icon class="mr-0">save_alt</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- <hr style="margin: 0" /> -->
      <div #navigation class="document scrollbar_scontract_xs" id="pdfContainer" style="height: calc(100vh - 195px); width: 100%">
<!--          <ng-container *ngIf="pdfSrc && createContractType === 0">-->
<!--            <ngx-extended-pdf-viewer class="pdf-viewer" [src]="pdfSrc" useBrowserLocale="true"-->
<!--              [showDownloadButton]="false" [showRotateButton]="false" [showOpenFileButton]="false"-->
<!--              [showBookmarkButton]="false" [showPropertiesButton]="false" [showUnverifiedSignatures]="true"-->
<!--              [sidebarVisible]="true" [enablePrint]="false" [theme]="'dark'" [language]="language"-->
<!--              height="calc(85vh - 140px)" style="display: block" [textLayer]="true"-->
<!--              (textLayerRendered)="textLayerFormRendered($event)" [handTool]="false" [(zoom)]="zoomLevel"-->
<!--              [httpHeaders]="authorization"></ngx-extended-pdf-viewer>-->
<!--          </ng-container>-->
          <ng-container *ngIf="pdfSrc && !loadSign && !isShowReferencePdf">
            <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
              (textLayerRendered)="textLayerRendered($event)" [(page)]="pageIndex" [enablePrint]="false"
              [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
              [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
              [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
              [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
               height="80vh" style="display: block" useBrowserLocale="true"
              [httpHeaders]="authorization">
            </ngx-extended-pdf-viewer>
        </ng-container>
        <ng-container *ngIf="pdfSrc && loadSign && !isShowReferencePdf">
          <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
                                   (textLayerRendered)="textLayerRendered($event)" [(page)]="pageIndex" [enablePrint]="false"
                                   [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
                                   [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
                                   [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
                                   [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                   height="80vh" style="display: block" useBrowserLocale="true"
                                   [httpHeaders]="authorization">
          </ngx-extended-pdf-viewer>
        </ng-container>

        <!-- No file -->
<!--        <div style="display: flex; justify-content: center; align-items: center">-->
<!--          <ng-template #notUpload>-->
<!--            <div *ngIf="!pdfSrc && !isHide" class="container">-->
<!--              <div class="drd-container">-->
<!--                <input #inputUpload (change)="onSelectedUpload($event)" accept="application/pdf"-->
<!--                  class="form-control-file vt-input-form d-none" id="file" multiple name="file" style="cursor: pointer"-->
<!--                  type="file" />-->
<!--                <br />-->
<!--                <button #btnUpload1 (click)="inputUpload.click()" [disabled]="warningContractQuantity"-->
<!--                  class="mr-2 mat-stroked-button-create-document" color="primary" id="btnUpload1" mat-stroked-button-->
<!--                  type="button">-->
<!--                  <mat-icon class="mr-0">cloud_upload</mat-icon>-->
<!--                  {{ "button.choose_a_file" | translate }}-->
<!--                </button>-->

<!--                <h5 style="margin-top: 2em">-->
<!--                  ({{ maxSizeError }})-->
<!--                </h5>-->
<!--                <br /><br />-->
<!--              </div>-->
<!--            </div>-->
<!--          </ng-template>-->
<!--        </div>-->
      </div>
      <hr style="margin: 0" />
    </div>
    <div class="scontract-btn-dsk bg-white text-center mat-elevation-z0 py-2 w-100">
      <button *ngIf="!checkMan" mat-stroked-button color="primary" class="btn mr-3" type="button" (click)="onBackClick()">
        <mat-icon class="mr-0">arrow_back</mat-icon>
        {{ "form.back" | translate }}
      </button>
      <button *ngIf="checkMan" (click)="closeData()" mat-stroked-button color="primary" class="btn mr-3" type="button" >
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "form.cancel" | translate }}
      </button>
      <button *ngIf="checkMan" (click)="openPopupSetUp()"  mat-raised-button class="mr-3" color="primary">
        {{'form.btn_CSTL' | translate}}
      </button>
      <button *ngIf="!checkMan && !isSetUpSignFlow " (click)="openPopupSetUp()"  mat-raised-button class="mr-3" color="primary">
        {{'form.btn_TLLKNB' | translate}}
      </button>
      <button (click)="onSaveSignFlow()"  *ngIf="checkMan"  mat-raised-button class="mr-3" color="primary">
        {{'form.btn_xacnhan' | translate}}
      </button>

    </div>
  </div>
</div>


